import React from "react";
import Chart from "react-apexcharts";

function BalPrisonPopulationTrend() {
  var options = {
    noData: {
      text: "No data is available!",
      align: "center",
      verticalAlign: "middle",
    },
    chart: {
      type: "line",
      background: "transparent",
      zoom: {
        enabled: false,
      },
    },
    series: [
      {
        name: "No of Prisoner",
        data: [48760, 45423, 52303, 52376, 50644],
      },
    ],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "straight",
    },
    theme: {
      mode: "light",
      //palette: "palette1"
    },
    grid: {
      show: false,
    },
    tooltip: {
      shared: false,
      intersect: true,
      onDatasetHover: {
        highlightDataSeries: true,
      },
    },
    marker: {
      size: 8,
      fillColor: "#fff",
      strokeColor: "red",
      radius: 2,
      cssClass: "apexcharts-custom-class",
    },
    states: {
      normal: {
        filter: {
          type: "none",
          value: 0,
        },
      },
      hover: {
        filter: {
          type: "darken",
          value: 0.15,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: "darken",
          value: 0.35,
        },
      },
    },
    markers: {
      size: 6,
      strokeColors: "#FFFFFF",
      strokeWidth: 2,
      strokeOpacity: 0.9,
      strokeDashArray: 0,
      fillOpacity: 0,
      // discrete: [
      //   {
      //     seriesIndex: 0,
      //     // dataPointIndex: 2,
      //     fillColor: "#C1573B",
      //     strokeColor: "#fff",
      //     size: 6,
      //   },
      // ],
      shape: "circle",
      radius: 2,
      offsetX: 0,
      offsetY: 0,
    },
    // labels: ["2018", "2019", "2020", "2021", "2022"],
    xaxis: {},
    xaxis: {
      // type: "datetime",
      categories: ["2018", "2019", "2020", "2021", "2022"],
    },
    yaxis: {
      max: 53000,
      min: 0,
    },
  };

  return (
    <div>
      <Chart
        options={options}
        series={options.series}
        type="line"
        width="100%"
      />
    </div>
  );
}

export default BalPrisonPopulationTrend;
